import React from "react";
import {registerPassages, jumpTo} from "../../Utils";
import {
    addTimePart,
    getDateString,
    getRandomItem,
    getTimeString,
    paymentDay,
    probabilityWorked
} from "../features/functions";
import Passage from "../../features/Passage";
import Link from "../../features/Link";
import V from "../../features/V";
import Image from "../../features/Image";
import images, {getRandomImage} from "../images";
import variables from "../variables";
import places from "../places/places";
import people, {currentPlayer} from "../people/people";
import Video from "../../features/Video";
import constants from "../constants";
import things from "../things";
import missions from "../missions";
import Say from "../../features/Say";
import Name from "../../features/Name";
import {Trans} from "react-i18next";

const beforeWakeUp = () => {
    variables.player.warnDidntGoToWork = false;
    console.log(JSON.stringify(variables.getJSON()));

    if (paymentDay()) return currentPlayer.goTo(places.rentMenu.id);
    if (people.wife.relations <= 0) return jumpTo("game.endBadRelationsWithWife");
    if (things.pillForJob.treated && !variables.story.pillForJobEffectBeginsIsShown)
        return jumpTo("story.pillForJobEffectBegins");

    variables.game.morningSetter && variables.game.morningSetter();
    variables.game.randomEvents.courierJob = false;
    variables.game.randomEvents.homeWife = false;
    variables.game.morningSetter = null;
    variables.wife.isDressedUp = false;

    jumpTo(variables.game.nextDayLink);
};

const changeDay = <Passage>
    <h1><Trans i18nKey="game.changeDay.header"/></h1>
    <br/>
    <Image src={images.game.sunrise} style={{width: "600px"}}/>
    <h2><V callback={getDateString}/></h2>
    <h2><V callback={getTimeString}/></h2>
    <br/><Link to="" callback={beforeWakeUp}><Trans i18nKey="game.changeDay.link"/></Link>
</Passage>

const endDidntPayRent = <Passage>
    <Trans i18nKey="game.endDidntPayRent">
        1<h1/><Image src={images.other.badEndBum}/><Name who={people.wife}/><Link to="start.startPassage"/>
    </Trans>
</Passage>

const endBadRelationsWithWife = <Passage>
    <Trans i18nKey="game.endBadRelationsWithWife">
        1<h1/><Image src={images.other.badEndDivorce}/><Name who={people.wife}/><Say who={people.player}/>
        <Say who={people.wife}/><Link to="start.startPassage"/>
        {{wife: people.wife.name, player: people.player.name}}
    </Trans>
</Passage>

const place = <Passage>
    <V callback={() => {variables.game.nowIsStory = false}}/>
    <V callback={() => (places.getCurrent())}/>
</Passage>

const playAsNow = <Passage>
    <Image src={images.other.turnsInto}/>
    <V callback={()=>{
        return (
            <div>
                <Trans i18nKey="game.playAsNow">
                    1<h2/><Link to="" callback={()=>{currentPlayer.goTo(currentPlayer.where)}}/>{{name: currentPlayer.name}}
                </Trans>
            </div>
        );
    }}/>
</Passage>

const courierJob = <Passage>
    <V callback={()=>{
        if (probabilityWorked(constants.player.probabilities.courierJobEvent) && !variables.game.randomEvents.courierJob) {
            const nextPassage = getRandomItem([
                "game.courierJobEventMoto", "game.courierJobEventCar", "game.courierJobEventDelivery",
                "game.courierJobEventDelivery1", "game.courierJobEventDelivery2", "game.courierJobEventDelivery3",
                "game.courierJobEventStairs", "game.courierJobEventStore"
            ]);
            variables.game.randomEvents.courierJob = true;
            jumpTo(nextPassage);
        }
    }}/>
    <Trans i18nKey="game.courierJob.e01">1<h1/><Image src={images.player.drive.van}/></Trans>
    <V callback={() => {
        if (variables.game.time[1] === 2)
            return (
                <div>
                    <Trans i18nKey="game.courierJob.e02">1<Link to={"game.courierGoHome"}/></Trans>
                </div>
            )
        return (
            <div>
                <Trans i18nKey="game.courierJob.e03">
                    1<Link to="game.place" callback={() => {
                    if (variables.wife.messages.player[3] !== "mes04")
                        people.player.sendNewMessage("mes04");
                    people.player.setLocation(places.courier.id);
                    addTimePart();
                    addTimePart();
                    people.wife.occupations.set();}}/>
                </Trans>
            </div>
        )
    }}/>
</Passage>

const courierJobEventMoto = <Passage>
    <Trans i18nKey="game.courierJobEventMoto">
        1<h1/><Video src={images.player.jobs.courier.events.bike} loop/><Link to="game.courierJob"/>
    </Trans>
</Passage>

const courierJobEventCar = <Passage>
    <Trans i18nKey="game.courierJobEventCar">
        1<h1/><Image src={images.player.jobs.courier.events.carFlash}/><Link to="game.courierJob"/>
    </Trans>
</Passage>

const courierJobEventDelivery = <Passage>
    <Trans i18nKey="game.courierJobEventDelivery">
        1<h1/><Say who={people.mother}/><Video src={images.player.jobs.courier.events.delivery} loop/><Say who={people.player}/>
        <Link to="game.courierJob"/>
    </Trans>
</Passage>

const courierJobEventDelivery1 = <Passage>
    <Trans i18nKey="game.courierJobEventDelivery1">
        1<h1/><Video src={images.player.jobs.courier.events.delivery1} loop/><Say who={people.mother}/><Link to="game.courierJob"/>
    </Trans>
</Passage>

const courierJobEventDelivery2 = <Passage>
    <Trans i18nKey="game.courierJobEventDelivery2">
        1<h1/><Video src={images.player.jobs.courier.events.delivery2} loop/><Link to="game.courierJob"/>
    </Trans>
</Passage>

const courierJobEventDelivery3 = <Passage>
    <Trans i18nKey="game.courierJobEventDelivery3">
        1<h1/><Say who={people.father}/><Say who={people.player}/><Video src={images.player.jobs.courier.events.delivery3} loop/>
        <Link to="game.courierJob"/>
    </Trans>
</Passage>

const courierJobEventStairs = <Passage>
    <Trans i18nKey="game.courierJobEventStairs">
        1<h1/><Say who={people.player}/><Say who={people.mother}/><Video src={images.player.jobs.courier.events.stairs} loop/>
        <Link to="game.courierJob"/>
    </Trans>
</Passage>

const courierJobEventStore = <Passage>
    <Trans i18nKey="game.courierJobEventStore">
        1<h1/><Video src={images.player.jobs.courier.events.store}/><Link to="game.courierJob" loop/>
    </Trans>
</Passage>

const courierGoHome = <Passage>
    <Trans i18nKey="game.courierGoHome">
        1<h1/><Image src={images.player.drive.van}/>
        <Link to="game.place" callback={() => {
            variables.player.warnDidntGoToWork = true;
            people.player.setLocation(places.homeMain.id);
            people.wife.occupations.set();
            people.player.set("money", people.player.money + constants.works.courier.salaryPerDay);}}/>
    </Trans>
</Passage>

const courierJobOffice = <Passage>
    <Trans i18nKey="game.courierJobOffice">
        1<h1/><Image src={images.player.jobs.courier.office}/><Link to="game.place"/>
    </Trans>
</Passage>

const courierJobOfficeWorker = <Passage>
    <V callback={()=>{
        missions.initCorruption_01.tasks.askAtOfficeAboutWife_01.isActive() && jumpTo("game.courierJobOfficeWorkerStart");
        currentPlayer.isWife() && jumpTo("game.courierJobOfficeWorkerAsWife");
    }}/>
    <h1><Name who={people.officeWorker}/></h1>
    <Image src={images.people.officeWorker}/>
    <Trans i18nKey="game.courierJobOfficeWorker">
        1<Say who={people.officeWorker}/><Say who={people.player}/>
        <Link to="" callback={()=>{currentPlayer.goTo(places.courierOffice.id)}}/><br/>
    </Trans>
</Passage>

const courierJobOfficeWorkerAsWife = <Passage>
    <h1><Name who={people.officeWorker}/></h1>
    <Image src={images.wife.actions.office.coworkerFlirt}/>
    <Trans i18nKey="game.courierJobOfficeWorkerAsWife">
        1<Name who={people.wife}/><Name who={people.officeWorker}/>
        <Link to="" callback={()=>{currentPlayer.goTo(places.courierOffice.id)}}/>
    </Trans>
</Passage>

const courierJobOfficeColleaguesAsWife = <Passage>
    <Trans i18nKey="game.courierJobOfficeColleaguesAsWife">
        1<h1/><Image src={images.wife.actions.office.colleagues}/><Name who={people.wife}/>
        <Link to="" callback={()=>{currentPlayer.goTo(places.courierOffice.id)}}/>
    </Trans>
</Passage>

const courierJobOfficeWifeDoNotDisturb = <Passage>
    <h1><Name who={people.wife}/></h1>
    <Image src={images.wife.actions.office.doNotDisturb}/>
    <Trans i18nKey="game.courierJobOfficeWifeDoNotDisturb">
        1<Say who={people.wife}/><Say who={people.player}/>
        <Link to="" callback={()=>{currentPlayer.goTo(places.courierOffice.id)}}/><br/>
        {{player: people.player.name}}
    </Trans>
</Passage>

const courierJobOfficeWorkerStart = <Passage>
    <Trans i18nKey="game.courierJobOfficeWorkerStart">
        1<h1/><Say who={people.player}/><Image src={images.people.officeWorker}/><Say who={people.officeWorker}/>
        <Name who={people.officeWorker}/>
        <Link to="" callback={()=>{
            missions.initCorruption_01.finishCurrentTask();
            currentPlayer.goTo(places.courier.id);}}/>
        {{player: people.player.name, wife: people.wife.name, worker: people.officeWorker.name}}
    </Trans>
</Passage>

const playComputer = <Passage>
    <Trans i18nKey="game.playComputer">
        1<h1/><V callback={() => (<Video src={getRandomImage(images.other.computerGame)}/>)} loop/>
        <Link to="" callback={() => {
            addTimePart(true);
            currentPlayer.goTo(places.homeBedroom.id);}}/>
    </Trans>
</Passage>

const watchPorn = <Passage>
    <V callback={()=>{
        if (currentPlayer.isWife())
            jumpTo("wife.watchPorn")
    }}/>
    <Trans i18nKey="game.watchPorn">
        1<h1/><V callback={() => (<Video src={getRandomImage(images.other.computerPorn)} muted={false} loop/>)}/>
        <Link to="" callback={() => {
            addTimePart(true);
            currentPlayer.goTo(places.homeBedroom.id);}}/>
    </Trans>
</Passage>

const dontGoOutsideAtNight = <Passage>
    <Trans i18nKey="game.dontGoOutsideAtNight">
        1<h1/><Image src={images.player.opensDoor}/><Link to="" callback={() => (currentPlayer.goTo(places.homeBedroom.id))}/>
    </Trans>
</Passage>

const cantGoToBathroom = <Passage>
    <Trans i18nKey="game.cantGoToBathroom">
        1<h1/><Image src={images.player.opensDoor}/><Name who={people.wife}/><div style={{color: "red"}}/><br/>
        <Link to="" callback={()=>{currentPlayer.goTo(places.homeBedroom.id)}}/>
        {{wife: people.wife.name, relations: constants.wife.relationsTo.goToBathroom}}
    </Trans>
</Passage>

const dontGoToWork = <Passage>
    <Trans i18nKey="game.dontGoToWork">
        1<h1/><Image src={images.player.opensDoor}/>
        <Link to="" callback={() => {variables.player.warnDidntGoToWork = true; return currentPlayer.goTo(places.homeMain.id);}}/>
    </Trans>
</Passage>

const pillsInstruction = <Passage>
    <Trans i18nKey="game.pillsInstruction.header">1<h1/></Trans>
    <Image src={images.story.readInstructions}/>
    <div style={{color: "orange", backgroundColor: "white", padding: "5px"}}>
        <Trans i18nKey="game.pillsInstruction.body">
            1<h3/><div style={{color: "red"}}/><strong/>
        </Trans>
    </div><br/>
    <Trans i18nKey="game.pillsInstruction.link">
        1<Link to="" callback={()=>{currentPlayer.goTo(places.homeBedroom.id);}}/>
    </Trans>
</Passage>

const sleep = <Passage>
    <Trans i18nKey="game.sleep">
        1<h1/><Image src={images.actions.sleepTogether}/>
        <Link to="game.changeDay" callback={()=>{
            addTimePart(true);
            variables.game.nextDayLink = "game.place";
            places.setCurrent(places.homeBedroom.id);}}/>
    </Trans>
</Passage>

const nap = <Passage>
    <Trans i18nKey="game.nap">
        1<h1/><Image src={images.actions.nap}/>
        <Link to="" callback={()=>{addTimePart(true); currentPlayer.goTo(places.homeBedroom.id);}}/>
    </Trans>
</Passage>

registerPassages({
    changeDay,
    endDidntPayRent,
    endBadRelationsWithWife,
    place,
    playAsNow,
    courierJob,
    courierJobEventMoto,
    courierJobEventCar,
    courierJobEventDelivery,
    courierJobEventDelivery1,
    courierJobEventDelivery2,
    courierJobEventDelivery3,
    courierJobEventStairs,
    courierJobEventStore,
    courierJobOffice,
    courierJobOfficeWorker,
    courierJobOfficeWorkerAsWife,
    courierJobOfficeColleaguesAsWife,
    courierJobOfficeWifeDoNotDisturb,
    courierJobOfficeWorkerStart,
    courierGoHome,
    playComputer,
    watchPorn,
    dontGoOutsideAtNight,
    dontGoToWork,
    pillsInstruction,
    cantGoToBathroom,
    sleep,
    nap
}, "game");